import { useState, useCallback } from "react";
import { getDocumentConfigURL } from "../utils/ConstantsURL";
import { toastAlert } from "../utils/AlertContext";

export const useGetDocumentConfig = (token) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchConfig = useCallback(
    async (documentId) => {
      if (!documentId) {
        setError("Se requiere un documentId válido");
        return null;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(getDocumentConfigURL(documentId), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.message ||
              `Error ${response.status}: No se pudo obtener la configuración del documento`
          );
        }

        const json = await response.json();

        const fetchedConfig = json?.data ?? null;
        setConfig(fetchedConfig);
        return fetchedConfig;
      } catch (err) {
        const message =
          err.message || "Error desconocido al obtener la configuración del documento";
        setError(message);
        toastAlert("Error al cargar la configuración del documento: " + message, "error");
        return null;
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  return { config, loading, error, fetchConfig };
};
